import { FormControl, FormLabel, Input, Switch } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";

import FixedBar from "components/ui/FixedBar";
import SubmitButton from "components/ui/SubmitButton";
import { useSuccessDialogContext } from "components/ui/SuccessDialog/SuccessDialogContext";
import { useMessages } from "hooks/useMessages";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Inputs, useSavePerson } from "../hooks/useSavePerson";

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
});

type FormProps = {
  person?: any;
};

export default function PersonForm({ person }: FormProps) {
  const defaultValues: Inputs = {
    name: person?.name,
    active: person?.active,
  };

  const navigate = useNavigate();
  const { openSuccessDialog } = useSuccessDialogContext();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(validationSchema) as Resolver<Inputs>,
    defaultValues,
  });

  const { onError } = useMessages();

  const isActive = watch("active");

  const { onSavePerson, isPending } = useSavePerson({
    personId: person?.id,
    onSuccess: () => {
      reset();
      navigate("/parlamentares");
      if (!person?.id) {
        openSuccessDialog({
          title: "Novo parlamentar cadastrado!",
          description: "",
          actionButtonText: "Criar mais um parlamentar",
          actionButton: "/parlamentares/novo",
          closeButtonText: "Tudo certo",
        });
      }
    },
    onError: (error) => onError(error?.response?.data?.message),
  });

  const onSubmit: SubmitHandler<Inputs> = (data) => onSavePerson(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={!!errors.name} isRequired>
        <FormLabel>Nome</FormLabel>
        <Input {...register("name")} autoFocus />
      </FormControl>

      {person && (
        <FormControl isInvalid={!!errors.active}>
          <FormLabel>Status</FormLabel>
          <Switch {...register("active")}>
            {isActive ? "Ativo" : "Inativo"}
          </Switch>
        </FormControl>
      )}

      <FixedBar>
        <SubmitButton isDisabled={isPending || !isValid} isLoading={isPending}>
          {!person ? "Cadastrar" : "Atualizar"}
        </SubmitButton>
      </FixedBar>
    </form>
  );
}
